import create from "zustand";
export const useCarousel = create((set) => ({
    shouldOpen: false,
    showCoachMark: false,
    setShouldOpen: (shouldOpen) => set({ shouldOpen }),
    setShowCoachMark: (showCoachMark) => set({ showCoachMark }),
}));
